package pl.decks.personal.components.widgets.ranks.shapes

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Polygon
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.toAttrs
import pl.decks.personal.components.widgets.ranks.SVGLine
import pl.decks.personal.components.widgets.ranks.line
import kotlin.math.cos
import kotlin.math.PI
import kotlin.math.sin

@Composable
fun RankStar(
    innerRadius: Float = 20f,
    color: Color = Colors.White,
    modifier: Modifier = Modifier,
) {
    fun <T> List<T>.alternate(other: List<T>): List<T> =
        indices.flatMap { listOf(this[it], other[it]) }

    val outerRadius = 50f
    val height = 100f
    val width = 100f
    val cx = width / 2
    val cy = height / 2
    val spokeCount = 5

    val outerPoints = (0 until spokeCount).map { i ->
        val angle = PI / spokeCount * 2 * i - PI / 2
        (cx + outerRadius * cos(angle)).toFloat() to (cy + outerRadius * sin(angle)).toFloat()
    }
    val innerPoints = (0 until spokeCount).map { i ->
        val angle = PI / spokeCount * (2 * i + 1) - PI / 2
        (cx + innerRadius * cos(angle)).toFloat() to (cy + innerRadius * sin(angle)).toFloat()
    }

    val points: SVGLine = outerPoints.alternate(innerPoints)

    Box(modifier) {
        Svg(
            attrs = Modifier
                .fillMaxSize()
                .toAttrs {
                    attr("viewBox", "0 0 $width $height")
                    attr("preserveAspectRatio", "none")
                }
        ) {
            Polygon {
                attr("points", points.line())
                attr("fill", color.toString())
                attr("stroke", "none")
            }
        }
    }
}
